import React from 'react';
import './DeleteAccount.css';

export default function DeleteAccountPage(): React.ReactElement {
  return (
    <div className="delete-account-page">
      <div className="delete-account-container">
        <header className="delete-account-header">
          <h1 className="delete-account-title">Hereabout Account Deletion</h1>
        </header>

        <section className="delete-account-section">
          <h2>How to Delete Your Account</h2>
          <p>
            You can permanently delete your account and all associated data directly in the Hereabout app by going to: <strong>User Profile → Settings → Account Settings → Delete Account</strong>
          </p>

          <h2>What Happens When You Delete Your Account</h2>
          <p>
            When you confirm deletion, your account, posts, and media are permanently removed from our servers within 30 days. Some backups may persist for up to 90 days for security purposes.
          </p>

          <h2>Need Help?</h2>
          <p>
            If you have questions or need assistance with account deletion, please contact us at{' '}
            <a href="mailto:engineering@stormbyte.dev">engineering@stormbyte.dev</a>
          </p>
        </section>
      </div>

      <div className="delete-account-footer">
        <div>© 2025 Stormbyte LLC — All rights reserved.</div>
        <div>
          Contact: <a href="mailto:engineering@stormbyte.dev">engineering@stormbyte.dev</a>
        </div>
      </div>
    </div>
  );
}
